module.exports = __webpack_public_path__ + "img/school.5e02f7e8.png";